/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
export default (({
  children
}) => /*#__PURE__*/_jsx("div", {
  className: "subtitle",
  children: children
}));